import { useState } from 'react';

interface PlaygroundEmbedProps {
  playgroundId: string;
}

export default function PlaygroundEmbed({ playgroundId }: PlaygroundEmbedProps) {
  const [isLoading, setIsLoading] = useState(true);

  const embedUrl = `https://playground.getsequence.io/?id=${playgroundId}&embed=true`;

  return (
    <div className="playground-embed">
      {isLoading && (
        <div className="playground-embed__skeleton" aria-label="Loading playground" />
      )}
      <iframe
        className="playground-embed__iframe"
        src={embedUrl}
        title="Sequence Playground"
        onLoad={() => setIsLoading(false)}
        style={{ display: isLoading ? 'none' : 'block' }}
        allow="clipboard-write"
      />
    </div>
  );
}
